import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-image-modal',
  standalone: true,
  imports: [],
  templateUrl: './image-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageModalComponent {
  activeModal = inject(NgbActiveModal);

  imageUrl = input.required<string>();
  alt = input('');
}
